import { useState } from 'react';

import { TagDTO } from '@gearbelt/global';
import { Button } from '@gearbelt/ui/components';

import PencilIcon from '@/components/icons/pencil';
import { Badge } from '@/components/ui/badge';

import { UpdateWorkspaceIssueTags } from './update-workspace-issue-tags';

function IssueTags({
  onTagsChange,
  issueTags,
  disabled = false,
}: {
  onTagsChange: (tags: TagDTO[]) => void;
  issueTags: TagDTO[] | undefined;
  disabled?: boolean;
}) {
  const [openIssuesTagsUpdate, setOpenIssuesTagsUpdate] = useState(false);

  return (
    <div className="flex w-full items-start gap-4">
      <p className="text-default-text w-[350px] shrink-0 text-sm">Issue tags</p>
      <div className="flex min-w-px flex-1 flex-col gap-2">
        {issueTags && issueTags.length > 0 ? (
          <div className="flex flex-wrap gap-1">
            {issueTags.map((issueTag) => (
              <Badge key={issueTag.id} size="sm" variant="orange">
                {issueTag.tag}
              </Badge>
            ))}
          </div>
        ) : (
          <div className="text-secondary-text text-sm">No issue tags have been created yet.</div>
        )}
        {!disabled && (
          <Button
            variant="ghost"
            type="button"
            icon={<PencilIcon />}
            className="bg-grey-1 hover:bg-grey-3 w-fit"
            onClick={() => {
              setOpenIssuesTagsUpdate(true);
            }}>
            Edit Tags
          </Button>
        )}
      </div>

      <UpdateWorkspaceIssueTags issueTags={issueTags} open={openIssuesTagsUpdate} onOpenChange={setOpenIssuesTagsUpdate} callback={onTagsChange} />
    </div>
  );
}

export default IssueTags;
